import React, { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { WidgetEditor, Widget } from 'jamespot-front-business';
import { useIntl } from 'react-intl';

import { EditorInputSelect } from './components/EditorInputSelect';
import { useAppDispatch, useAppSelector } from '../../redux/store';

/**
 *
 * level 1 : Icon only (iOS like)
 * level 2 : Icon + Notification cell (iOS like)
 * level 3 : Default display
 * Level 4 : ???
 *
 */
export const EditorTabDisplayLevel = ({ uniqid }: { uniqid: string }) => {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const editor = useAppSelector((state) => WidgetEditor.selectors.selectEditor(state, uniqid), shallowEqual);
    const def = Widget.definition(editor?.name);
    const level = useAppSelector((state) => Widget.selectors.selectWidgetLevel(state, uniqid), shallowEqual);

    const handleChange = useCallback(
        (level: string) => {
            dispatch(Widget.slice.actions.updateWidgetWrapper({ uniqid, level: Number(level) as 1 | 2 | 3 | 4 }));
        },
        [uniqid, dispatch],
    );

    return (
        <EditorInputSelect
            handleChange={handleChange}
            required={true}
            label={'WIDGET_Display_Level_Select'}
            initialValue={level ? String(level) : '3'}
            options={[
                { label: intl.formatMessage({ id: 'WIDGET_Display_Level_1' }), value: '1' },
                { label: intl.formatMessage({ id: 'WIDGET_Display_Level_2' }), value: '2' },
                { label: intl.formatMessage({ id: 'WIDGET_Display_Level_3' }), value: '3' },
                { label: intl.formatMessage({ id: 'WIDGET_Display_Level_4' }), value: '4' },
            ].filter((el) =>
                Array.isArray(def.displayLevel) ? def.displayLevel.includes(Number(el.value) as 1 | 2 | 3 | 4) : [],
            )}
        />
    );
};
